
import { Button } from "@/components/ui/button";

interface ProPageHeaderProps {
  onShowWaitlist: () => void;
}

export const ProPageHeader = ({ onShowWaitlist }: ProPageHeaderProps) => {
  return (
    <div className="max-w-4xl mx-auto text-center">
      <h1 className="text-4xl sm:text-5xl font-bold text-primary mb-8">
        Développez votre activité dans l'Aisne
      </h1>
      
      <div className="mb-8 text-lg text-gray-600 font-medium">
        <p className="mb-4">
          Vous êtes un acteur du tourisme dans l'Aisne ?
        </p>
        <div className="flex flex-wrap justify-center gap-2 text-base">
          <span className="px-3 py-1 bg-primary/10 rounded-full">Hébergements</span>
          <span className="px-3 py-1 bg-primary/10 rounded-full">Restaurants</span>
          <span className="px-3 py-1 bg-primary/10 rounded-full">Bars</span>
          <span className="px-3 py-1 bg-primary/10 rounded-full">Événementiel</span>
          <span className="px-3 py-1 bg-primary/10 rounded-full">Activités & Loisirs</span>
        </div>
      </div>

      <p className="text-xl text-gray-600 mb-12">
        Rejoignez NLocale et donnez un coup de boost à votre visibilité locale. 
        Plus de clients, moins de stress, et surtout : pas de commission !
      </p>

      <Button 
        onClick={onShowWaitlist}
        size="lg"
        className="text-lg"
      >
        Rejoindre la communauté locale
      </Button>
    </div>
  );
};
